// import { connectRouter } from 'redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import history from '../utils/history';

import loginReducer from './reducers/loginSlice';
// import appReducer from './reducers/appSlice';
import employeeReducer from './reducers/employeeSlice';
import expenseSlice from './reducers/expenseSlice';
import payrollSlice from './reducers/payrollSlice';
import reportSlice from './reducers/reportSlice';

const reducers = combineReducers({
  login: loginReducer,
  // app: appReducer,
  employee: employeeReducer,
  expense: expenseSlice,
  payroll: payrollSlice,
  report: reportSlice,
  router: connectRouter(history),
});
const rootReducer = (state, action) => {
  if (action.type === 'login/logout') {
    storage.removeItem('persist:root');
    return reducers(undefined, action);
  }
  return reducers(state, action);
};
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['employee', 'expense'],
};
const persistedReducers = persistReducer(persistConfig, rootReducer);

const middleware = [...getDefaultMiddleware(), routerMiddleware(history)];

export default configureStore({
  reducer: persistedReducers,
  middleware,
  devTools: true, // process.env.NODE_ENV !== 'production',
});
